import React, { useState } from "react";
import logo from "../img/Wa.I.San Jpeg final.jpg";
import { NavLink } from "react-router-dom";
import "./Header.css";
import { FaMoon, FaLock, FaPlus } from "react-icons/fa";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(""); // Track which dropdown is open

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setOpenDropdown("");
  };

  const handleDropdownToggle = (dropdown) => {
    if (window.innerWidth <= 768) {
      setOpenDropdown((prevState) => (prevState === dropdown ? "" : dropdown));
    }
  };

  const handleMouseEnter = (dropdown) => {
    if (window.innerWidth > 768) {
      setOpenDropdown(dropdown);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 768) {
      setOpenDropdown("");
    }
  };

  // Close menu when clicking outside
  const handleOutsideClick = (e) => {
    if (!e.target.closest(".header")) {
      closeMenu();
    }
  };

  React.useEffect(() => {
    window.addEventListener("click", handleOutsideClick);
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="DreamsTour Logo" className="logo" />
      </div>

      <button
        className="hamburger-menu"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        ☰
      </button>

      <nav className={`navbar ${menuOpen ? "show" : ""}`}>
        <ul className="nav-links">
          <li className="nav-item">
            <NavLink
              to="/home"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/about-us"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              About Us
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/heritage"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
               Heritage Walks and Tours
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/activities"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
               Activities
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/conservation"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
             Conservation
            </NavLink>
          </li>

         
          {/* Explore Dropdown */}
          <li
            className="dropdown-container"
            onMouseEnter={() => handleMouseEnter("explore")}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleDropdownToggle("explore")}
          >
            <span className="nav-span">Explore{" "} <span className="dropdown-icon">
              <i className="fa-solid fa-angle-down"></i>
            </span></span>
           
            <ul
              className={`dropdown-menu ${
                openDropdown === "explore" ? "show" : ""
              }`}
            >
              <li>
                <NavLink to="/explore/education-awareness" onClick={closeMenu}>
                  Education and Awareness
                </NavLink>
              </li>
             
              <li>
                <NavLink to="/explore/blogs" onClick={closeMenu}>
                  Blogs
                </NavLink>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <NavLink
              to="/upcoming"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Upcoming
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/team"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Team
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/contact-us"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Contact Us
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
